import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { specializations } from '@services/api'

export class specializationsStore extends StoreExt {
    @observable list = []

    @action
    getSpecializations = async () => {
        const { data: list } = await specializations.getList()
        runInAction(() => {
            this.list = list
        })
    }
}

export default remotedev(new specializationsStore())
